import { Block } from 'slate';
import tag from './preTag';
import getRole from '../../../../../../../../../store/constants/getRole';
import scrollToSlateNode from './scrollToSlateNode';
import scrollToNextSlateNode from './scrollToNextSlateNode';
import { fnBrowserDetect } from '../../../../../../../../../utility/browsers';
import { SAFARI } from '../../../../../../../../../utility/enums/browsers';

export default (event, editor, currentRoleNode, statusBarRef, props) => {
  const { universityPlan } = props;
  event.preventDefault();
  const {
    value: { document: prevDocument, focusBlock },
  } = editor;

  /**
   * Fetch organization data
   */
  const organization = prevDocument.getParent(currentRoleNode.key);
  const {
    data: organizationData,
    nodes: organizationNodes,
    key: organizationKey,
  } = organization;
  const selectAll = organizationData.get('selectAll');

  /**
   * Create a new role block
   */
  const preTag = tag[currentRoleNode.type];
  const roleNode = Block.create({
    type: currentRoleNode.type,
    nodes: getRole({ preTag, universityPlan }),
    data:
      preTag === 'skill'
        ? {
            toExport: true,
            rating: 0,
            maxRating: 5,
          }
        : {
            toExport: true,
          },
  });

  /**
   * Editor needs a paragraph always to insert Role custom node
   * because a Role node would not accept a Role node
   * please refer the Role schema for more details
   *
   * When dragging is introduced, we need to make sure a paragraph stays always
   * at the beginning of the organization
   *
   * moveForward(n) // n > 1 // is not working with the current version
   * when shifting from block to block
   */

  const indexOfCurrentRole = organizationNodes
    .toArray()
    .indexOf(currentRoleNode);

  editor.insertNodeByKey(organizationKey, indexOfCurrentRole + 1, roleNode);

  /**
   * Update the organization data
   */
  editor.setNodeByKey(organization.key, {
    data: {
      ...organizationData.toJSON(),
      selectAll: selectAll + 1,
    },
  });

  /**
   * Update the document data
   */

  const {
    value: { document: updatedDocument },
  } = editor;

  const { key: documentKey, data: updatedDocumentData } = updatedDocument;
  const updatedDocumentDataJSON = updatedDocumentData.toJSON();
  const { rolesCount } = updatedDocumentDataJSON;
  editor.setNodeByKey(documentKey, {
    data: {
      ...updatedDocumentDataJSON,
      rolesCount: rolesCount + 1,
    },
  });

  /**
   * By default the native selection would drop at the last division
   * it sees in the content editable div, but we need to force it to move
   * back to the beginning of the node but ignoring the label
   */

  const nextBlock = updatedDocument.getNextBlock(currentRoleNode.key);
  editor.moveToStartOfNode(nextBlock);
  if (window.env !== 'test' && fnBrowserDetect() !== SAFARI) editor.focus();
  if (preTag === 'skill') {
    scrollToNextSlateNode(
      focusBlock,
      statusBarRef,
      updatedDocument,
      nextBlock,
      props,
    );
  } else {
    const newlyAddedRole = updatedDocument.getNextSibling(currentRoleNode.key);
    scrollToSlateNode(newlyAddedRole);
  }
};
